import claimDrawer from '@/translations/en/claims/claim-drawer';
import createClaim from '@/translations/en/claims/create-claim';
import createClaimRework from '@/translations/en/claims/create-claim-rework';
export default {
  claimDrawer,
  createClaim,
  createClaimRework,
};
